<script setup lang="ts">

/* Vue */
import { reactive, onMounted, ref, computed, nextTick } from "vue";

/* serviços */
import * as service from "@/services/BoletosService";
import { addDays, fdata, f2dec, fdataHora, salvarFiltros, carregarFiltros } from "@/utils/funcoes";

/* componentes */
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";

var exibirFiltros = ref(false);

var controle = reactive({
    filtros: {
        statusId: 1,
        paginaAtual: 1,
        tamanhoPagina: 500 
    } as service.BoletoFiltros
});

var interno = reactive({
    status: [] as Array<service.EnumModel>,
    ocorrencias: [] as Array<service.EnumModel>,
})

let tempoEsperaPesquisa = 0 as ReturnType<typeof setTimeout> | number;

const emit = defineEmits(["onPesquisar"]);

const disparar = () => {
    emit("onPesquisar", controle.filtros);
    salvarFiltros("boletosFiltros", controle.filtros);
}

const preparaPesquisa = () => {
    clearTimeout(tempoEsperaPesquisa);
    tempoEsperaPesquisa = setTimeout(disparar, 700);
}

const selecAll = (event: any) => {
    event.target.select();
}


const inputFocus = ref(null) as any;

onMounted(() => {

    

    setTimeout(() => {

        var filtros = carregarFiltros("boletosFiltros");

        if (filtros)
            controle.filtros = filtros;

         service.obterOpcoes().then( r => {
            console.log("obtendo opções", r);
            interno.status = r.status;
            interno.ocorrencias = r.ocorrenciasRemessa;
        })

        disparar();

        var el = document.getElementById("inputFocus");
        if (el != null && el != undefined)
            el.focus();

    }, 100);
})

function limparFiltros() {
    controle.filtros.boletoId = null;
    controle.filtros.clienteId = null;
    controle.filtros.dataVencIni = null;
    controle.filtros.dataVencFim = null;
    controle.filtros.statusIds = null;
    controle.filtros.nossoNumero = null;
    controle.filtros.pedidoId = null;
    controle.filtros.dataCadIni = null;
    controle.filtros.dataCadFim = null;
    controle.filtros.dataDocIni = null;
    controle.filtros.dataDocFim = null;

    nextTick(() => {
        disparar();
        inputFocus.value?.focus();
    })
}

</script>

<template>
    <TrataTecla>
        <div class="row ">
            <div class="col-lg col-6 pe-0 mb-1">
                <label>Pesquisar</label>
                <input type="text" class="form-control form-control-sm" placeholder="Pesquisar Cliente, Nome" v-model="controle.filtros.nome" @keyup="preparaPesquisa" @focus="selecAll"
                    ref="inputFocus" id="inputFocus"/>
            </div>

            <div class="col-lg col-6 pe-0 mb-1">
                <label>Dt. Emissão Ini</label>
                <TextBox :formato="'Data'" class="form-control form-control-sm" id="dataCadIni" v-model="controle.filtros.dataCadIni" 
                    @alteraValor="preparaPesquisa" />
            </div>

            <div class="col-lg col-6 pe-0 mb-1">
                <label>Dt. Emissão Fin</label>
                <TextBox :formato="'Data'" class="form-control form-control-sm" id="dataCadFim" v-model="controle.filtros.dataCadFim"
                    @alteraValor="preparaPesquisa" />
            </div>

            <div class="col-lg col-6 pe-0 mb-1">
                <label>Dt Docto Ini</label>
                <TextBox :formato="'Data'" class="form-control form-control-sm" id="dataDocIni" v-model="controle.filtros.dataDocIni"
                    @alteraValor="preparaPesquisa" />
            </div>

            <div class="col-lg col-6 pe-0 mb-1">
                <label>Dt Docto Fin</label>
                <TextBox :formato="'Data'" class="form-control form-control-sm" id="dataDocFim" v-model="controle.filtros.dataDocFim"
                    @alteraValor="preparaPesquisa" />
            </div>

            <!-- <div class="col-lg col-6 pe-0 mb-1">
                <label>Nosso número</label>
                <TextBox :formato="'Texto'" class="form-control form-control-sm" id="nossoNumero" v-model="controle.filtros.nossoNumero" 
                    @alteraValor="preparaPesquisa" />
            </div> -->


             <div class="col-lg col-6 pe-0 mb-1">
                <label>Status</label>
                <select  v-model="controle.filtros.statusId"  class="form-select form-select-sm"  @change="disparar()"  >
                    <option :value="null">Todos</option>
                    <option v-for="(item, idx) in interno.status" :key="idx" :value="item.posicao">{{ item.texto }}</option>
                </select>
            </div>
            
            <div class="col-6 col-lg-auto text-nowrap">

                <a class="btn btn-primary btn-sm me-1 mt-3" @click="disparar()" title="Atualizar busca">
                    <i class="flaticon-search"></i> 
                </a>

                <a class="btn btn-primary btn-sm  me-1 mt-3" @click="limparFiltros()" title="Limpar os filtros">
                    <i class="flaticon-close"></i>
                </a>

            </div>

        </div>
    </TrataTecla>
</template>

<style scoped>
.sticky-top {
    top: 60px;
}
</style>